import * as d3 from 'd3'
export default {
  methods: {

     exec_Popup(msg, type, data) {
    
      let execCanvas = this.svg
      .append('g')
      .attr('id', `EXEC_MESSAGE`)
      .attr('transform', `translate(0, 0)`)

      execCanvas
      .append('rect')
      .attr('id', `EXEC_BACKGROUND`)
      .attr('rx', 10).attr('ry', 10).attr('width', this.winProps.width).attr('height', this.winProps.height).attr('fill', '#fff').attr('opacity', .8)

      let width = 354, height = 168
      let winH = this.winProps.height == this.Canvas.CanvasHeight ? 150 : 50
      let message = execCanvas
      .append('g')
      .attr('transform', `translate(${this.winProps.width/2-(width/2)}, ${this.winProps.height/2-(height/2) - winH})`)

      message
      .append('rect')
      .attr('x', 2).attr('y', 2)
      .attr('width', width).attr('height', height).attr('rx', 5).attr('ry', 5)
      .attr('fill', '#fff').attr('stroke', '#000').attr('stroke-width', 0)
      .attr('filter', 'url(#msgShadow)').style('opacity', .3)

      message
      .append('image')
      .attr('x', 0).attr('y', 0).attr('height', 172)
      .attr('xlink:href', type =='edit' ? this.HOST + `/Database/popup/Confirm2.svg` :  this.HOST + `/Database/popup/Confirm.svg`)

      let msgList = message
      .append('g')
      .attr('transform', `translate(100, 72)`)

      msg.forEach((d,i)=> {
        msgList
        .append('text')
        .attr('y', i*18).attr('fill', d.color ? d.color : '#333').attr('font-size', d.size ? d.size : 13)
        .text(d.text)
      })

      // Ok
      message 
      .append('image').attr('cursor', 'pointer')
      .attr('xlink:href', type =='edit' ? this.HOST + `/Database/btn/Edit.svg` : this.HOST + `/Database/btn/Ok_Blue.svg`)
      .attr('x', 170).attr('y', 130).attr('width', 80).attr('cursor', 'pointer')
      .on('mouseover', function() { d3.select(this).transition().duration(75).style('opacity', .5) })
      .on('mouseout', function() { d3.select(this).transition().duration(250).style('opacity', 1) })
      .on('click', () => {
        d3.select(`#EXEC_MESSAGE`).remove()
        this.execution(type, data)
      })

      // Cancel
      message 
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/btn/Cancel.svg`).attr('x', 260).attr('y', 130).attr('width', 80).attr('cursor', 'pointer')
      .on('mouseover', function() { d3.select(this).transition().duration(75).style('opacity', .5) })
      .on('mouseout', function() { d3.select(this).transition().duration(250).style('opacity', 1) })
      .on('click', () => {d3.select(`#EXEC_MESSAGE`).remove()})
    },

    
    execution(type, data) {

      switch(type) {
        case 'STAGE':
          this.exeProc_Stage(data)
        break
        case 'edit':
          this.winProps = {exeFunc: this.dia_Router, width: 900, height: 720, mode: 'edit', idx: data.IDX,}
          this.gmx_drawWindow()
        break
        default:
          this.exeProc_Diagram(type, data)
      }

    },


    exeProc_Stage(stg) {

      let proc = this.db_Table.filter(f=> f.IDX == stg.IDX && f.STG_NO == stg.STG_NO && f.RELATION == 'Exec')

      proc.forEach(d=> {
        console.log(`${d.DATABASE}.${d.SCHEMA}.${d.NAME}`)
      })

    },


    exeProc_Diagram(type, dia) {
      
      switch(type) {
        case 'CUTOFF':
          console.log(`[${dia.CTO_DB}].[${dia.CTO_SCM}].[${dia.CTO_TBL}] -> ${dia.CTO_CODE} -> ${dia.CTO_DATE.slice(0, 10)}`)
        break
        case 'VERIFY':
          console.log(dia.VERIFY)
        break
        case 'DEV':
          console.log(`[${dia.DEV_DB}].[${dia.DEV_SCM}].[${dia.DEV_SP}]`)
        break
        case 'SERVICE':
          console.log(`[${dia.SVS_DB}].[${dia.SVS_SCM}].[${dia.SVS_SP}]`)
        break
      }
    },

  }
  
}